import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import React from "react";
import Sidebar from "../components/dashboard/Sidebar";
import TopBar from "../components/dashboard/TopBar";
import { useAurelioBuilder } from "../context/AurelioBuilderContext";

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { isFullscreen, editorData } = useAurelioBuilder();

  // Debug navigation and fullscreen state
  useEffect(() => {
    console.log("DashboardLayout - Current path:", location.pathname);
    console.log("DashboardLayout - Search params:", location.search);
    console.log("DashboardLayout - AurelioBuilder state:", { 
      isFullscreen, 
      editorData 
    });
  }, [location, isFullscreen, editorData]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Si Aurelio Builder está en modo fullscreen, solo mostrar el contenido
  if (isFullscreen) {
    return (
      <div className="h-screen bg-[#0f0f0f] text-gray-100 overflow-hidden">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </div>
    );
  }

  // Modo normal con sidebar y topbar
  return (
    <div className="h-screen bg-[#121212] text-gray-100 overflow-hidden flex">
      {/* Sidebar component */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="flex-1 flex flex-col min-h-screen">
        <TopBar toggleSidebar={toggleSidebar} />
        <main className="flex-1 overflow-y-auto bg-[#121212] p-4">
          <div id="dashboard-content" className="h-full">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </div>
        </main>
      </div>
    </div>
  );
}

// Error boundary component to catch and display render errors
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("DashboardLayout Error Boundary caught an error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 bg-[#1e1e1e] rounded-lg border border-[#ff1b6d]">
          <h2 className="text-xl font-bold text-white mb-4">Error de renderizado</h2>
          <p className="text-red-400 mb-4">{this.state.error?.message || "Error desconocido"}</p>
          <div className="bg-[#121212] p-4 rounded border border-[#2a2a2a] overflow-auto max-h-[300px]">
            <pre className="text-gray-300 text-sm whitespace-pre-wrap">
              {this.state.errorInfo?.componentStack || "No hay detalles adicionales"}
            </pre>
          </div>
          <button 
            onClick={() => window.location.reload()} 
            className="mt-4 px-4 py-2 bg-[#ff1b6d] text-white rounded hover:bg-[#ff1b6d]/90"
          >
            Recargar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default DashboardLayout;
